import React from 'react';

function CookiesSEO() {
  return <meta name="description" content="Cookies closure website" />;
}

export default CookiesSEO;
